<div class="content" pTooltip="{{ contenuTooltipOccupation() }}" (click)="onClickVoirEtatZoneDeTravail()">
	<div class="progress-bar"
		 [style.--taux-occupation]="tauxOccupationAvecIconePourcentage()"
		 [style.--couleur-jauge]="couleurJauge()">
		<progress value="{{ occupationZoneDeTravail().valeurTauxOccupation }}" min="0" max="100" style="visibility:hidden;height:0;width:0;">{{ tauxOccupationAvecIconePourcentage() }}</progress>
		<span class="valeur-taux-occupation">{{ occupationZoneDeTravail().valeurTauxOccupation }}%</span>
	</div>
</div>
